import apiClient from "./apiClient";

export type SalesCsvMapping = {
  accountName: string;
  contactEmail: string;
  amount: string;
  closeDate: string;
  soldItems: string;
};

export type SalesCsvSeparators = {
  delimiter: string;
  quote?: string;
};

export type SalesCsvSkippedRowSample = {
  rowNumber: number;
  reason: string;
};

export type ImportSalesCsvResponse = {
  importId: string;
  status: string;
  csvStoredOnS3: boolean;
  totalRows: number;
  importedCount: number;
  skippedCount: number;
  skippedRowsSample: SalesCsvSkippedRowSample[];
};

export const importSalesCsv = async (params: {
  file: File;
  mapping: SalesCsvMapping;
  separators: SalesCsvSeparators;
}) => {
  const formData = new FormData();
  formData.append("file", params.file);
  formData.append("mapping", JSON.stringify(params.mapping));
  formData.append("separators", JSON.stringify(params.separators));

  const response = await apiClient.post("/sales-import/csv", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data as ImportSalesCsvResponse;
};

export const downloadSkippedRowsCsv = async (importId: string) => {
  const response = await apiClient.get(`/sales-import/${importId}/skipped-rows.csv`, {
    responseType: "blob",
  });
  return response.data as Blob;
};

